window.EditarItensOrcamentoItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-editar-itens-orcamento-item-view",
    form: "#form-editar-item-orcamento",

    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
        this.finalizarEdicaoItemCallback = options.finalizarEdicaoItemCallback;
        this.cancelarEdicaoItemCallback = options.cancelarEdicaoItemCallback;
    },

    events: {
        'click #aplicar-editar-item-orcamento': "aplicar"
    },

    onShow: function() {
        this.configurarForm();
        $("#DespesasInclusas").attr("checked", this.model.get("DespesasInclusas"));
        this.ui.quantidade.focus();
    },

    configurarForm: function() {

        this.validationOptions = {
            errorClass: "obrigatorio",
            onkeyup: false,
            errorPlacement: function(error, element) {
                return true;
            },
            focusInvalid: false,
            invalidHandler: function(event, validator) {

                var errors = validator.numberOfInvalids();

                if (errors) {
                    var messages = new Array();

                    $.each(validator.errorList,
                        function() {
                            messages.push(this.message);
                        });

                    global.showErrorMessage(messages);

                    return false;
                }
            },
            rules: {
                'Quantidade': {
                    required: true,
                    minValue: 0,
                    numberMaxValue: "double"
                }
            },
            messages: {
                'Quantidade': {
                    required: 'O campo "quantidade" é obrigatório.',
                    minValue: 'O valor do campo "quantidade" não pode ser menor ou igual a 0.',
                    numberMaxValue: 'O valor do campo "quantidade" é muito grande e não é suportado.'
                }
            }
        };

        $(this.form, this.$el).validate(this.validationOptions);

    },

    aplicar: function(e, mostrarMensagem) {

        if (!$(this.form, this.$el).valid()) {
            return false;
        }

        var formdata = global.convertFormToJSON({
            element: $(this.form, this.$el)
        });

        this.model.alterarQuantidade(formdata.Quantidade, $.proxy(this.quantidadeAlterada, this, mostrarMensagem));

    },

    quantidadeAlterada: function (mostrarMensagem) {
        if (typeof mostrarMensagem == "undefined" || mostrarMensagem) {
            global.showSuccessMessage("Item alterado com sucesso.");
        }

        if (this.finalizarEdicaoItemCallback) {
            this.finalizarEdicaoItemCallback(this.model);
        }
    }

});

window.EditarItensOrcamentoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-editar-itens-orcamento-composite-view",
    childView: EditarItensOrcamentoItemView,
    childViewContainer: "#lista-editar-itens-orcamento-container",
    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
        this.finalizarEdicaoItemCallback = options.finalizarEdicaoItemCallback;
        this.cancelarEdicaoItemCallback = options.cancelarEdicaoItemCallback;
        this.aplicarTudoCallback = options.aplicarTudoCallback;
    },

    buildChildView: function(item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this,
            controller: this.controller,
            finalizarEdicaoItemCallback: this.finalizarEdicaoItemCallback,
            cancelarEdicaoItemCallback: this.cancelarEdicaoItemCallback
        });

        if (this.controller) {
            view.controller = this.controller;
        }

        return view;
    },

    aplicarTudo: function() {

        $.each(this.children._views,
            function() {
                this.aplicar(null, false);
            });

        global.showSuccessMessage("Itens alterados com sucesso.");

        if (this.aplicarTudoCallback) {
            this.aplicarTudoCallback();
        }

    }
});